import { cardAnatomy } from '@chakra-ui/react/anatomy';
import { defineSlotRecipe } from '@chakra-ui/react/styled-system';

const stepsCardAnatomy = cardAnatomy.extendWith('titleGroup');

const stepCardSlotRecipe = defineSlotRecipe({
  className: 'steps-card',
  slots: stepsCardAnatomy.keys(),
  base: {
    root: {
      backgroundColor: 'background/primary',
      border: '1px solid',
      borderColor: 'border/minimal',
      borderRadius: '8',
      boxShadow: 'elevation/md',
      overflow: 'hidden',
    },
    header: {
      paddingBlockStart: '32',
      paddingInline: { base: '24', tablet: '32' },
    },
    body: {
      display: 'flex',
      flexDirection: 'column',
      gap: '24',
      paddingBlockEnd: '48',
      paddingBlockStart: '32',
      paddingInline: { base: '24', tablet: '32' },
    },
    titleGroup: {
      display: 'flex',
      flexDirection: 'column',
      gap: '4',
    },
    title: {
      color: 'text/primary',
      textStyle: 'heading/h3',
    },
    description: {
      color: 'text/secondary',
      textStyle: 'body/md/regular',
    },
    footer: {
      alignItems: 'center',
      borderBlockStart: '1px solid',
      borderColor: 'border/minimal',
      display: 'flex',
      gap: '16',
      justifyContent: 'flex-end',
      padding: { base: '24', tablet: '32' },
    },
  },
});

export default stepCardSlotRecipe;
